"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TenantContext", {
  enumerable: true,
  get: function get() {
    return _tenantContext.TenantContext;
  }
});
Object.defineProperty(exports, "TenantIcon", {
  enumerable: true,
  get: function get() {
    return _TenantIcon["default"];
  }
});
Object.defineProperty(exports, "accessConfig", {
  enumerable: true,
  get: function get() {
    return _access["default"];
  }
});
Object.defineProperty(exports, "facebookConfig", {
  enumerable: true,
  get: function get() {
    return _facebook["default"];
  }
});
Object.defineProperty(exports, "facebookTheme", {
  enumerable: true,
  get: function get() {
    return _facebook2["default"];
  }
});
Object.defineProperty(exports, "tiktokConfig", {
  enumerable: true,
  get: function get() {
    return _tiktok["default"];
  }
});
Object.defineProperty(exports, "tiktokTheme", {
  enumerable: true,
  get: function get() {
    return _tiktok2["default"];
  }
});
Object.defineProperty(exports, "twitchConfig", {
  enumerable: true,
  get: function get() {
    return _twitch["default"];
  }
});
Object.defineProperty(exports, "twitchTheme", {
  enumerable: true,
  get: function get() {
    return _twitch2["default"];
  }
});
Object.defineProperty(exports, "twitterConfig", {
  enumerable: true,
  get: function get() {
    return _twitter["default"];
  }
});
Object.defineProperty(exports, "twitterTheme", {
  enumerable: true,
  get: function get() {
    return _twitter2["default"];
  }
});
Object.defineProperty(exports, "useTenant", {
  enumerable: true,
  get: function get() {
    return _tenantContext.useTenant;
  }
});
Object.defineProperty(exports, "withTenantContext", {
  enumerable: true,
  get: function get() {
    return _withTenantContext["default"];
  }
});
Object.defineProperty(exports, "youtubeConfig", {
  enumerable: true,
  get: function get() {
    return _youtube["default"];
  }
});
Object.defineProperty(exports, "youtubeDVTheme", {
  enumerable: true,
  get: function get() {
    return _youtubeDv2["default"];
  }
});
Object.defineProperty(exports, "youtubeTheme", {
  enumerable: true,
  get: function get() {
    return _youtube2["default"];
  }
});
Object.defineProperty(exports, "ytdvConfig", {
  enumerable: true,
  get: function get() {
    return _youtubeDv["default"];
  }
});
var _tenantContext = require("./tenant-context");
var _withTenantContext = _interopRequireDefault(require("./withTenantContext"));
var _TenantIcon = _interopRequireDefault(require("./TenantIcon"));
var _access = _interopRequireDefault(require("./access/access.config"));
var _facebook = _interopRequireDefault(require("./facebook/facebook.config"));
var _facebook2 = _interopRequireDefault(require("./facebook/facebook.theme"));
var _tiktok = _interopRequireDefault(require("./tiktok/tiktok.config"));
var _tiktok2 = _interopRequireDefault(require("./tiktok/tiktok.theme"));
var _twitch = _interopRequireDefault(require("./twitch/twitch.config"));
var _twitch2 = _interopRequireDefault(require("./twitch/twitch.theme"));
var _twitter = _interopRequireDefault(require("./twitter/twitter.config"));
var _twitter2 = _interopRequireDefault(require("./twitter/twitter.theme"));
var _youtube = _interopRequireDefault(require("./youtube/youtube.config"));
var _youtube2 = _interopRequireDefault(require("./youtube/youtube.theme"));
var _youtubeDv = _interopRequireDefault(require("./youtube-dv/youtube-dv.config"));
var _youtubeDv2 = _interopRequireDefault(require("./youtube-dv/youtube-dv.theme"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }